import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import travelPlansReducer from './slices/travelPlansSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    travelPlans: travelPlansReducer,
  },
}); 